import { faLock, faUnlockAlt, faUsers } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import cx from 'classnames';
import { Location } from 'history';
import {
    ENTER_TO_GROUP,
    GROUP_ASK_TO_JOIN,
    GROUP_ASKED_TO_JOIN,
    GROUP_counter_ACTIVE_MEMBERS,
    JOIN_GROUP,
    NEW_FEMININE,
} from 'mk/autogenerated/translations/GroupGridItem.67c59bf42d63770adafeb5b8b8094ce8'
import { isAuthenticated } from 'mk/bazaar/common/userUtils';
import assetUrl from 'mk/common/assetUrl';
import { photoUrl } from 'mk/photo/photoUrl';
import { groupsGroupUrl } from 'mk2/apps/groups/urls';
import { loginUrl } from 'mk2/apps/users/urls';
import Btn, { BtnType } from 'mk2/components/Btn';
import Clamp from 'mk2/components/Clamp';
import Img from 'mk2/components/Img';
import Interpolate from 'mk2/components/Interpolate';
import Link from 'mk2/components/Link';
import LoadingPlaceholder from 'mk2/components/LoadingPlaceholder';
import Panel from 'mk2/components/Panel';
import { url } from 'mk2/helpers/urls';
import { PhotoEntity, UserEntity } from 'mk2/schemas';
import React from 'react';
import styles from './GroupGridItem.mscss';

interface OwnProps {
    activeMembersCount: number;
    className?: string;
    coverPhoto?: PhotoEntity;
    description: string;
    hasAskedForMembership?: boolean;
    id: number;
    isJoining?: boolean;
    isMember?: boolean;
    location: Location;
    locked?: boolean;
    newIcon?: boolean;
    requestUser: UserEntity;
    title: string;
    newBadge?: boolean;
    horizontal?: boolean;

    onJoinGroup(groupId: number);
}

type Props = OwnProps;

export default class GroupGridItem extends React.PureComponent<Props> {

    public static defaultProps: Partial<Props> = {
        hasAskedForMembership: false,
        isJoining: false,
        isMember: false,
        locked: false,
        newBadge: false,
        horizontal: false,
    };

    public render() {
        const {
            className, title, description, activeMembersCount, locked, coverPhoto, isMember, id,
            isJoining, hasAskedForMembership, requestUser, location, newIcon, newBadge, horizontal,
            onJoinGroup,
        } = this.props;

        return (
            <Panel
                className={cx(
                    styles.GroupGridItem,
                    horizontal && styles['GroupGridItem--horizontal'],
                    className,
                )}
            >
                <div
                    className={cx(
                        styles.GroupGridItem__photoPart,
                        horizontal && styles['GroupGridItem__photoPart--horizontal'],
                    )}
                >
                    <Link
                        className={cx(styles.GroupGridItem__photo, styles['GroupGridItem__photo--empty'])}
                        to={url(groupsGroupUrl, { groupId: id })}
                        style={coverPhoto ? { backgroundImage: `url(${photoUrl(coverPhoto, 's742xn')})` } : undefined}
                    >
                        {!coverPhoto && (
                            <FontAwesomeIcon icon={faUsers} />
                        )}
                        <div className={styles.GroupGridItem__icon}>
                            {newIcon ? (
                                <Img
                                    src={assetUrl + `img/icons/${locked ? 'locked' : 'unlocked'}.png`}
                                    width={18}
                                    height={16}
                                />
                            ) : (
                                <FontAwesomeIcon icon={locked ? faLock : faUnlockAlt} className={locked ? styles['GroupGridItem__icon--locked'] : styles['GroupGridItem__icon--unlocked']}/>
                            )}
                        </div>
                    </Link>
                </div>
                <div
                    className={cx(
                        styles.GroupGridItem__contentPart,
                        horizontal && styles['GroupGridItem__contentPart--horizontal'],
                    )}
                >
                    <Link
                        className={cx(
                            styles.GroupGridItem__content,
                            horizontal && styles['GroupGridItem__content--horizontal'],
                        )}
                        to={url(groupsGroupUrl, { groupId: id })}
                    >
                        <Clamp clamp={5}>
                            <div className={styles.GroupGridItem__content__text}>
                                <h3 className={styles.GroupGridItem__title}>{title}</h3>
                                {newBadge &&
                                    <span className={styles.GroupGridItem__title__badge}>{NEW_FEMININE}</span>}
                                <br />
                                <p
                                    className={cx(
                                        styles.GroupGridItem__description,
                                        horizontal && styles['GroupGridItem__description--horizontal'],
                                    )}
                                >
                                    {description}
                                </p>
                            </div>
                        </Clamp>
                        <div className={styles.GroupGridItem__members}>
                            <Interpolate
                                i18nKey={GROUP_counter_ACTIVE_MEMBERS}
                                count={activeMembersCount}
                                counter={(
                                    <strong>{activeMembersCount}</strong>
                                )}
                            />
                        </div>
                    </Link>
                    <div className={styles.GroupGridItem__action}>
                        <Btn
                            link={!isAuthenticated(requestUser)
                                ? url(loginUrl, {},  {next: location.pathname}) : (
                                    (isMember || !onJoinGroup) ? url(groupsGroupUrl, { groupId: id }) : undefined
                                )}
                            onClick={(isMember || !isAuthenticated(requestUser) || !onJoinGroup) ? undefined : this.handleJoinGroup}
                            className={styles.GroupGridItem__action__button}
                            type={(isMember || hasAskedForMembership) ? BtnType.Link : BtnType.BlueOutline}
                            label={
                                isMember ? ENTER_TO_GROUP : (
                                    hasAskedForMembership ? GROUP_ASKED_TO_JOIN :
                                        (locked ? GROUP_ASK_TO_JOIN : JOIN_GROUP)
                                )}
                            hasSpinner={isJoining}
                            disabled={isJoining || hasAskedForMembership}
                        />
                    </div>
                </div>
            </Panel>
        );
    }

    private handleJoinGroup = (event: React.MouseEvent<HTMLAnchorElement>) => {
        event.preventDefault();
        this.props.onJoinGroup(this.props.id);
    };
}

interface GroupGridItemPlaceholderOwnProps {
    className?: string;
    horizontal?: boolean;
}

export const GroupGridItemPlaceholder: React.StatelessComponent<GroupGridItemPlaceholderOwnProps> = ({
    className,
    horizontal = false,
}) => (
    <Panel
        className={cx(
            styles.GroupGridItem,
            horizontal && styles['GroupGridItem--horizontal'],
            className,
        )}
    >
        <div
            className={cx(
                styles.GroupGridItem__photoPart,
                horizontal && styles['GroupGridItem__photoPart--horizontal'],
            )}
        >
            <span className={cx(styles.GroupGridItem__photo, styles['GroupGridItem__photo--empty'])}>
                <FontAwesomeIcon icon={faUsers} />
                <div className={styles.GroupGridItem__icon}>
                    <LoadingPlaceholder width={18} height={18} />
                </div>
            </span>
        </div>
        <div
            className={cx(
                styles.GroupGridItem__contentPart,
                horizontal && styles['GroupGridItem__contentPart--horizontal'],
            )}
        >
            <span className={styles.GroupGridItem__content}>
                <h3 className={styles.GroupGridItem__title}><LoadingPlaceholder width="80%"/></h3>
                <div className={styles.GroupGridItem__description}>
                    <LoadingPlaceholder width="90%" />
                    <LoadingPlaceholder width="85%" />
                    <LoadingPlaceholder width="30%" />
                </div>
                <div className={styles.GroupGridItem__members}>
                    <LoadingPlaceholder width="75%"/>
                </div>
            </span>
            <div className={styles.GroupGridItem__action}>
                <LoadingPlaceholder height={34} width="100%" />
            </div>
        </div>
    </Panel>
);
